import { useContext } from "react";
import { useProposalMode } from "@services/collections/assignment-proposal/assignmentProposalServices";
import { isLinkClosedToProposals, isProposing } from "@utils/assignmentProposal";
import { AppContext } from "../context/EditSessionsContext";
import { useActiveProposal } from "./useActiveProposal";

/**
 * True when a requester would propose changes (a new proposal, a draft or a correction) on a link
 * with microprogramming pending or applied. A sent proposal and a review keep their own rules.
 */
export const useIsLinkClosedToProposals = (): boolean => {
  const { state } = useContext(AppContext);
  const { isProposalMode } = useProposalMode();
  const activeProposal = useActiveProposal();

  return (
    isProposalMode && isProposing(activeProposal) && isLinkClosedToProposals(state?.link?.info)
  );
};
